// extracted by mini-css-extract-plugin
export default {"loadingButton":"VLoz8DX---styles_loadingButton__zkKAJ","loading":"VLoz8DX---styles_loading__CbZ5B"};